module.exports = __webpack_public_path__ + "static/media/SA.479bb907.svg";